export default "__VITE_ASSET__Dhgs8kjt__"